import React from "react";
import { PRIVACY_URL, TERMS_URL } from "../data/landing";
import { LOGO_URL } from "./TopBar";
export function Footer() {
  return <footer className="border-t border-line bg-ink" data-id="element-194" data-mp="3ggtwodvnbb34">
      <div className="page-container pb-28 pt-8 sm:pb-20" data-id="element-195" data-mp="32oe3e4sjqrfe">
        <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-196" data-mp="32lrkj907gphv">
          <img src={LOGO_URL} alt="Studio Web VIP" className="h-9 w-auto self-start object-contain sm:self-auto" data-id="element-197" data-mp="36ppj9ilmbyae" />
          <nav aria-label="Legal" className="flex gap-6 font-ui text-[13px] font-bold text-muted" data-id="element-198" data-mp="3ud7h9vvh7slt">
            <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-[48px] items-center transition-colors duration-200 ease-out hover:text-gold" data-id="element-199" data-mp="36d44znhyxod">
              Política de Privacidad
            </a>
            <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-[48px] items-center transition-colors duration-200 ease-out hover:text-gold" data-id="element-200" data-mp="2a1jhr4jztm0c">
              Términos
            </a>
          </nav>
        </div>
        <p className="mt-6 border-t border-line pt-6 text-[13px] leading-snug text-muted md:hidden" data-id="element-201" data-mp="3v7gha5qpmkbx">
          <span className="font-ui font-bold text-gold" data-id="element-202" data-mp="3q83svgk6x578">Programa Cliente Fundador — solo 3 cupos</span>{" "}
          · Aventura, Sunny Isles, Hallandale, Hollywood
        </p>
        <p className="mt-6 border-t border-line pt-6 text-[13px] text-muted" data-id="element-203" data-mp="80ntcj7a4qcv">
          © 2026 Studio Web VIP LLC · Florida · Serving Clients Nationwide
        </p>
      </div>
    </footer>;
}